export default ['$scope', 'options', function ($scope, options) {
  this.enable =  options.enable;
  this.confirm = () => {
    options.onConfirm();
    $scope.$close();
  };
}];
